<template>
   <div class="usservice">
        <div class="contents industry-contents-title">
            <img :width="aboutTitleWidth" :src="aboutTitle">
        </div>
        <div class="service-list contents">
            <div class="service-item" v-for="service in services">
                <div class="service-img">
                    <img :src="service.titleImg">
                </div>
                <p class="service-title">
                    {{service.title}}
                </p>
                <p class="service-info">
                    {{service.info}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
     props: {
        aboutTitle: {
            type: String,
            required: true,
            default: ""
        },
        aboutTitleWidth:{
            type:String,
            required: true,
            default: "630px"
        },
        services:{
            type:Array,
            required: true,
            default:function(){
                return []
            }
        }
    },
}
</script>

<style scoped>
    .industry-contents-title{
         text-align: center;
         padding-top:55px;
         margin-bottom:60px;
     }
     .service-list{
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        margin-bottom: 110px;
    }
    .service-item{
        width: 25%;
        text-align: center;
        height: 500px;
    }
    .service-item .service-img{
        margin-top: 47px;
        margin-bottom: 33px;
        position:relative;
    }
    .service-item .service-img::after{
        position:absolute;
        top:60px;
        right: 0;
        width: 1px;
        height: 90px;
        content: '';
        background-color: #DBDBDB;
    }
    .service-item:last-child .service-img::after{
        display: none;
    }
    .service-item .service-img img{
        width:180px;
        height: 200px;
    }
    .service-item .service-info{
        color: #333;     
        font-size: 14px;
        line-height: 2;
        padding:0 23px;
        font-family: Helvetica Neue,Helvetica,PingFang SC,\5FAE\8F6F\96C5\9ED1,Tahoma,Arial,sans-serif;
    }
    .service-item .service-title{
        color: #333333;
        font-weight: 700;
        font-size: 20px;
        margin-bottom: 13px;
    }
</style>


// WEBPACK FOOTER //
// src/components/brand/RenderService.vue